export const formatSearchFormInput = reportQuery => {
	return reportQuery;
};
